import { render, staticRenderFns } from "./TermsDetail.vue?vue&type=template&id=f745d88c&scoped=true"
import script from "./TermsDetail.vue?vue&type=script&lang=js"
export * from "./TermsDetail.vue?vue&type=script&lang=js"
import style0 from "./TermsDetail.vue?vue&type=style&index=0&id=f745d88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f745d88c",
  null
  
)

export default component.exports